export default "__VITE_ASSET__DQo2a$6l__"